import React from "react";
import { useAuth } from "../context/AuthContext";

interface Integration {
  name: string;
  description: string;
  connected: boolean;
}

const integrations: Integration[] = [
  {
    name: "Facebook",
    description: "Post scheduling & analytics",
    connected: false,
  },
  {
    name: "Instagram",
    description: "Reels, posts & DM automation",
    connected: false,
  },
  {
    name: "YouTube",
    description: "Insights & tag extraction",
    connected: false,
  },
  {
    name: "WhatsApp Business",
    description: "Auto reply & broadcast",
    connected: false,
  },
  {
    name: "Google Business",
    description: "Review & listing management",
    connected: false,
  },
];

const IntegrationsPanel: React.FC = () => {
  const { user, openAuthModal } = useAuth();

  const handleConnect = (name: string) => {
    if (name === "YouTube") {
      if (!user) {
        alert("Please login to connect your YouTube account.");
        openAuthModal();
        return;
      }

      // Redirect to backend OAuth flow
      const backendUrl = "https://socialmediawebappdotnet-c5gvgzgqauekgmej.westindia-01.azurewebsites.net";
      window.location.href = `${backendUrl}/api/youtube/connect?userId=${user.sub}`;
    } else if (name === "Facebook") {
      if (!user) {
        alert("Please login to connect your Facebook account.");
        openAuthModal();
        return;
      }

      // Redirect to backend OAuth flow for Facebook
      const backendUrl = "https://socialmediawebappdotnet-c5gvgzgqauekgmej.westindia-01.azurewebsites.net";
      window.location.href = `${backendUrl}/api/facebook/connect?userId=${user.sub}`;
    } else {
      alert(`Connect feature for ${name} is coming soon!`);
    }
  };

  return (
    <div>
      <h1
        style={{
          fontSize: "28px",
          fontWeight: 800,
          marginBottom: "30px",
          color: "#714B67",
        }}
      >
        Connect Your Platforms
      </h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "20px",
        }}
      >
        {integrations.map((item, index) => (
          <div
            key={index}
            style={{
              background: "#ffffff",
              padding: "25px",
              borderRadius: "16px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h3
                style={{
                  marginBottom: "8px",
                  fontWeight: 700,
                  color: "#2D3748",
                }}
              >
                {item.name}
              </h3>

              <p
                style={{
                  fontSize: "14px",
                  color: "#666",
                  marginBottom: "20px",
                }}
              >
                {item.description}
              </p>
            </div>

            <button
              onClick={() => handleConnect(item.name)}
              style={{
                padding: "10px",
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
                backgroundColor: item.connected ? "#017E84" : "#714B67",
                color: "#fff",
                fontWeight: 600,
              }}
            >
              {item.connected ? "Connected" : "Connect"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntegrationsPanel;
